/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React from 'react';
import BaseUrls from '../../../utils/baseUrls';
import { prefixPath } from '../../../utils/helpers';

export type GuideComponentProp = {
    next: ()=>void
}

const GuideComponent = ({ next }:GuideComponentProp) => {
  const baseUrl = window.location.origin;
  const theme = BaseUrls.getkey();
  const logo = baseUrl + prefixPath(`/img/${theme}/navLogo.png`);

  return (
<>
                <div className="container d-flex justify-content-center mt-4 pt-5">
                    {/* right part starts here */}
                    <section className="col-xl-5 addCloudBody col-lg-5 col-md-7 col-sm-12 p-5">
                        <div className="col-xl-10 mx-auto">
                            <div className="text-center mt-5 mb-4">
                             <img src={logo} className="img-responsive" alt="logo" />
                            </div>
                            <h5 className="mb-5 text-center">Add Tencent Cloud</h5>
                            <h6>Please follow these steps</h6>
                            <div className="mt-3">
                                <ul>
                                    <li>
Create an OIDC IdP. Click
{' '}
<a href="https://zeeve.atlassian.net/wiki/spaces/ZP/pages/361332754/How+to+Add+OIDC+based+SSO+in+Tencent+Cloud#Creating-an-OIDC-IdP" target="_blank" rel="noreferrer">here</a>
{' '}
for tutorial.
                                    </li>
                                    <br />
                                    <li>
                                        Get ProviderId and RoleArn. Click
{' '}
<a href="https://zeeve.atlassian.net/wiki/spaces/ZP/pages/361332754/How+to+Add+OIDC+based+SSO+in+Tencent+Cloud#Get-the-RoleArn-and-ProviderId-Name" target="_blank" rel="noreferrer">here</a>
   {' '}
for tutorial.
                                    </li>
                                    <br />
                                    <li>
Please apply for
{' '}
<a href="https://console.tencentcloud.com/vpc/package" target="_blank" rel="noreferrer">this</a>
{' '}
 bandwidth package before creating network in order to setup your blockchain node successfully.
                                    </li>
                                    <br />
                                </ul>
                            </div>

                            <div className="mt-4 mb-5  col-xl-12 col-lg-12 col-md-12 text-center">
                                <button type="submit" id="createBtn" className="btn comingSoon" onClick={() => { next(); }}>
                                    Next
                                </button>
                            </div>
                        </div>
                    </section>
                    {/* right part ends here */}
                </div>

</>
  );
};

export default GuideComponent;